// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"106":"944e1a32a18bfbe5","609":"537d30ca7444208b","825":"ab91989d2fb0a1f6"}[chunkId] + ".js";
};